// extracted by mini-css-extract-plugin
export default {"failedPage":"et9ZU6","failedCard":"CfGv2h","failedTitle":"XQLB8S","failedText":"cpCpYu"};